import { ColumnDef } from './ExpansionTable'
import { Theme, makeStyles } from '@forgeglobal/design-framework'

export const ExpansionTableStyles = makeStyles((theme: Theme) => ({
  colSpec: (props: Array<ColumnDef>) => {
    let colSpec: { [key: string]: any } = {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    }
    props.forEach(
      (col, i) =>
        (colSpec[`& > :nth-child(${i + 1})`] = {
          flex: `${col.width}`,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        })
    )
    return colSpec
  },
}))
